module.exports = __webpack_public_path__ + "img/mask_text.3a9d626e.png";